"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTradeById = void 0;
const qs_1 = __importDefault(require("qs"));
async function fetchTradeById(axiosInstance, storeId, queryDto) {
    let queryString = '';
    const { offset, limit = 10, identifiers } = queryDto || {};
    let queryObj = {};
    if (identifiers) {
        queryObj.identifier = identifiers;
        // queryString = qs.stringify({ identifier: identifiers }, { indices: false });
    }
    if (offset) {
        queryObj = { ...queryObj, offset, limit };
    }
    queryString = qs_1.default.stringify(queryObj, { indices: false });
    return axiosInstance.get(`/trade/${storeId}?${queryString}`).then((response) => response.data);
}
exports.fetchTradeById = fetchTradeById;
